import { JSONSchema4 } from 'json-schema';
/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface GetComplianceActionsSchemaContract {
  payroll_month: string;
  is_kapt_payment_window_open?: boolean;
  ka_pt_window_open_day?: number;
  actions: {
    'run-payroll': {
      status:
        | 'completely_executed'
        | 'partially_executed'
        | 'finalized'
        | 'not_initiated'
        | 'pending'
        | 'processing';
      meta: {
        last_payroll_executed?: null | string;
        payroll_executed_employees?: number;
        payroll_executed_employees_pending?: number;
        payroll_executed_employees_total?: number;
        display_name: string;
        message?: string;
        [k: string]: unknown;
      };
      [k: string]: unknown;
    };
    'pay-pt': {
      /**
       * This interface was referenced by `undefined`'s JSON-Schema definition
       * via the `patternProperty` "^[a-zA-Z ]+$".
       */
      [k: string]: {
        is_portal_down?: boolean;
        status:
          | 'in_progress'
          | 'not_initiated'
          | 'failed'
          | 'success'
          | 'paid_manually'
          | 'return_failed'
          | 'transaction_payment_pending'
          | 'refunded';
        meta: {
          amount?: {
            name?: string;
            value?: number;
            currency?: string;
            [k: string]: unknown;
          }[];
          supporting_doc?: {
            id?: string;
            link?: string;
            [k: string]: unknown;
          }[];
          payroll_executed_employees?: number;
          payroll_executed_employees_pending?: number;
          payroll_executed_employees_total?: number;
          /**
           * Employees covered by this payment (those with a PT transaction).
           */
          pt_payment_employee_count?: number;
          /**
           * Amount of PT transactions still pending after the first payment succeeded; paid outside XPayroll and marked as paid externally.
           */
          pt_unpaid_amount?: number;
          /**
           * Employees whose PT transactions are still pending after the first payment succeeded.
           */
          pt_unpaid_employees?: number;
          /**
           * Employees in this month's payroll whose PT location is this state.
           */
          pt_eligible_employees?: number;
          /**
           * Payroll skipped, so no salary paid and no PT due - not a shortfall.
           */
          pt_skipped_employees?: number;
          /**
           * Still due to be executed - the only genuine gap in the payment.
           */
          pt_pending_employees?: number;
          mark_as_paid?: boolean;
          is_over_due?: boolean;
          due_date: string;
          payment_completion_expected_by?: string | null;
          payment_made_on?: string | null;
          display_name: string;
          message?: string;
          manual_payment_outside_payroll?: boolean | null;
          [k: string]: unknown;
        };
        [k: string]: unknown;
      };
    };
    [k: string]: unknown;
  };
  [k: string]: unknown;
}

export default <JSONSchema4>{
  type: 'object',
  properties: {
    payroll_month: { type: 'string' },
    is_kapt_payment_window_open: { type: 'boolean' },
    ka_pt_window_open_day: { type: 'number' },
    actions: {
      type: 'object',
      properties: {
        'run-payroll': {
          type: 'object',
          properties: {
            status: {
              enum: [
                'completely_executed',
                'partially_executed',
                'finalized',
                'not_initiated',
                'pending',
                'processing',
              ],
            },
            meta: {
              type: 'object',
              properties: {
                last_payroll_executed: { type: ['null', 'string'] },
                payroll_executed_employees: { type: 'number' },
                payroll_executed_employees_pending: { type: 'number' },
                payroll_executed_employees_total: { type: 'number' },
                display_name: { type: 'string' },
                message: { type: 'string' },
              },
              required: ['display_name'],
            },
          },
          required: ['status', 'meta'],
        },
        'pay-pt': {
          type: 'object',
          patternProperties: {
            '^[a-zA-Z ]+$': {
              type: 'object',
              properties: {
                is_portal_down: { type: 'boolean' },
                status: {
                  enum: [
                    'in_progress',
                    'not_initiated',
                    'failed',
                    'success',
                    'paid_manually',
                    'return_failed',
                    'transaction_payment_pending',
                    'refunded',
                  ],
                },
                meta: {
                  type: 'object',
                  properties: {
                    amount: {
                      type: 'array',
                      items: {
                        type: 'object',
                        properties: {
                          name: { type: 'string' },
                          value: { type: 'number' },
                          currency: { type: 'string' },
                        },
                      },
                    },
                    supporting_doc: {
                      type: 'array',
                      items: {
                        type: 'object',
                        properties: { id: { type: 'string' }, link: { type: 'string' } },
                      },
                    },
                    payroll_executed_employees: { type: 'number' },
                    payroll_executed_employees_pending: { type: 'number' },
                    payroll_executed_employees_total: { type: 'number' },
                    pt_payment_employee_count: {
                      type: 'number',
                      description:
                        'Employees covered by this payment (those with a PT transaction).',
                    },
                    pt_unpaid_amount: {
                      type: 'number',
                      description:
                        'Amount of PT transactions still pending after the first payment succeeded; paid outside XPayroll and marked as paid externally.',
                    },
                    pt_unpaid_employees: {
                      type: 'number',
                      description:
                        'Employees whose PT transactions are still pending after the first payment succeeded.',
                    },
                    pt_eligible_employees: {
                      type: 'number',
                      description:
                        "Employees in this month's payroll whose PT location is this state.",
                    },
                    pt_skipped_employees: {
                      type: 'number',
                      description:
                        'Payroll skipped, so no salary paid and no PT due - not a shortfall.',
                    },
                    pt_pending_employees: {
                      type: 'number',
                      description:
                        'Still due to be executed - the only genuine gap in the payment.',
                    },
                    mark_as_paid: { type: 'boolean' },
                    is_over_due: { type: 'boolean' },
                    due_date: { type: 'string' },
                    payment_completion_expected_by: { type: ['string', 'null'] },
                    payment_made_on: { type: ['string', 'null'] },
                    display_name: { type: 'string' },
                    message: { type: 'string' },
                    manual_payment_outside_payroll: { type: ['boolean', 'null'] },
                  },
                  required: ['display_name', 'due_date'],
                },
              },
              required: ['status', 'meta'],
            },
          },
        },
      },
      required: ['run-payroll', 'pay-pt'],
    },
  },
  required: ['payroll_month', 'actions'],
};
